import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';

@ComponentDecorator({
  props: {
    colorClass: String,
    background: String,
    text: String,
  },
})

export default class CubeFullTitle extends Vue {
}
